<template>
  <section>
    <notifications></notifications>
    <base-header>
      <div class="row align-items-center  pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-7 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <div>
            <h1 class="title-view">
              Coverage Area
            </h1>

            <div class="box-id">
              <h2 class="number-id">
                {{ branchs.name }}
              </h2>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-5 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0"
              type="outline-neutral"
              class="min-button btn-line-danger"
              @click="deleteMany()"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              type="primary"
              class="min-button"
              @click="
                $router.push(
                  `/coverage-areas/new?branch=${$route.params.id}&supplier=${branchs.supplier}`
                )
              "
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Coverage Area</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid">
      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2 mt-3"
          ></div>
          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-3 text-right"
          >
            <div class="d-inline-block mr-2 mb-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="viewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>
            <base-dropdown
              menu-on-right
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
              title="Actions"
            >
              <base-button slot="title" type="none" class="pl-0 pr-0 icon-only">
                <i class="flaticon-downloading-files mr-0 "></i>
              </base-button>
              <div
                class="dropdown-item"
                @click="download(selectedRows)"
                v-if="selectedRows.length > 0"
              >
                Selected Records
              </div>
              <div class="dropdown-item" @click="download()">All Records</div>
            </base-dropdown>
          </div>
        </div>
        <div>
          <pagination-block
            :pageCount="responseAreaByBranch.pages"
            v-model="currentPage"
            :total="responseAreaByBranch.count"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="preventPaginations"
            position="bottom"
          ></pagination-block>

          <b-table
            hover
            :items="responseAreaByBranch.docs"
            :fields="fields"
            sort-by.sync="nameArea"
            sort-asc.sync="true"
            selectable
            @row-selected="onRowSelected"
            select-mode="multi"
            ref="selectableTable"
            sort-icon-left
            responsive
            show-empty
            empty-filtered-text="There are no records matching your request"
            empty-text="There are no records to show"
            :stacked="cardview"
          >
            <template #head()="{ label, field: { key } }">
              <span v-if="key === 'selected'">
                <span
                  @click="clearSelected"
                  v-if="selectedRows.length == areas.length"
                  class="check-table selected"
                ></span>

                <span @click="selectAllRows" v-else class="check-table"></span>
              </span>
              <span v-else>{{ label }}</span>
            </template>
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true" class="check-table selected"></span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true" class="check-table"></span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>

            <template #cell(nameArea)="data">
              <router-link
                class="capitalize hide-data"
                :to="
                  `/coverage-areas/${data.item._id}?branch=${$route.params.id}`
                "
                >{{ data.item.code }}
              </router-link>
            </template>

            <template #cell(description)="data">
              <span class="multiline-3">{{ data.item.description }}</span>
            </template>

            <template #cell(branch)="data">
              <span class="hide-data" v-if="data.item.branch"
                >{{ data.item.branch.name }}
              </span>
            </template>

            <template #cell(country)="data">
              <span class="hide-data">{{
                data.item.branch.destination.country.name
              }}</span>
            </template>

            <template #cell(actions)="data">
              <el-tooltip content="Edit" placement="bottom">
                <router-link
                  class="icon-action text-blue"
                  :to="
                    `/coverage-areas/${data.item._id}?branch=${$route.params.id}`
                  "
                >
                  <i class="flaticon-pencil text-primary"></i>
                </router-link>
              </el-tooltip>
              <el-tooltip content="Duplicate" placement="bottom">
                <span
                  class="icon-action ml-2"
                  @click.stop="duplicateAreaService(data.item._id)"
                >
                  <i class="flaticon-copy"></i>
                </span>
              </el-tooltip>
              <el-tooltip content="Delete" placement="bottom">
                <span
                  class="icon-action text-danger ml-2"
                  @click="deleteAreaService(data.item._id)"
                >
                  <i class="flaticon-delete"></i>
                </span>
              </el-tooltip>
            </template>
          </b-table>

          <pagination-block
            :pageCount="responseAreaByBranch.pages"
            v-model="currentPage"
            :total="responseAreaByBranch.count"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="preventPaginations"
            position="bottom"
          ></pagination-block>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import endpoint from "../../Commons/Services/index";
import Swal from "sweetalert2";
import moment from "moment";
import localHelper from "../Commons/Helper";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import { goBack } from "../../../helpers/commons.helpers";
import { handleApiError } from "../../../core/services";
export default {
  name: "CoverageAreaOfDestinations",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      currentPage: 1,
      selectedRows: [],
      modal: false,
      branchs: {
        name: "",
        _id: "",
        supplier: ""
      },

      limit: 0,

      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "nameArea",
          label: "Area Code",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "text-left"
        },
        {
          key: "description",
          label: "Description",
          sortable: false,
          thStyle: { minWidth: "100px" },
          class: "text-left"
        },
        {
          key: "branch",
          label: "Destination",
          sortable: true,
          thStyle: { minWidth: "250px" },
          class: "text-left"
        },
        {
          key: "country",
          label: "Country",
          sortable: true,
          thStyle: { minWidth: "250px" },
          class: "text-left"
        },

        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ],
      cardview: false,
      branchId: null,
      view: "table"
    };
  },

  async created() {
    var bread = [
      {
        text: "Destinations",
        to: "/destinations"
      },

      {
        text: "Coverage Areas",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.branchId = this.$route.params.id;
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.getBranchData(this.branchId);
    await this.get(true, this.branchId, this.limit, this.currentPage);
  },
  methods: {
    async getBranchData(branchId) {
      try {
        let { data } = await endpoint.branches.services.getBranchById(
          branchId,
          this.sesion.token
        );
        if (data.code === 200) {
          let result = data.data;
          this.branchs.name = result.name;
          this.branchs.supplier = result.supplier._id;
        } else {
        }
      } catch (error) {
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.branchId, this.limit, this.currentPage);
      }
    },
    preventPaginations(page) {
      this.get(true, this.branchId, this.limit, page);
    },
    nextPaginations(page) {
      this.get(true, this.branchId, this.limit, page);
    },
    changePage(page) {
      this.get(true, this.branchId, this.limit, page);
    },
    onSelectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    async deleteAreaService(areaId) {
      let { value } = await Swal.fire({
        title: "Delete Coverage Area",
        text: "Are you sure do you want to delete this Coverage Area?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteAreaServiceById(areaId);
      }
    },
    async deleteAreaServiceById(areaId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.areas.services.deleteAreaById(
          areaId,
          this.sesion.token
        );
        this.setLoad(false);
        let result = data.data;
        if (result.deleted) {
          this.get(true, this.branchId, 1, this.currentPage);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Coverage Area has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async deleteMany() {
      let { value } = await Swal.fire({
        title: "Delete Coverage Areas",
        text: "re you sure do you want to delete the selected Coverages Area?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyAreasById(this.selectedRows);
      }
    },
    async deleteManyAreasById(areas = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.areas.services.deleteManyAreasById(
          { areas: areas },
          this.sesion.token
        );
        this.setLoad(true);
        let result = data.data;
        if (result.deleted) {
          this.get(true, this.branchId, 1, this.currentPage);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Coverage Areas has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(areas = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.exports.services.exportCSVAreas(
          { areas: areas },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `areas-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    handleError(error, message) {
      handleApiError(this, error, message);
    },
    goToPreviousPage() {
      goBack(this);
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    viewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    get(loader, branchId, limit, page) {
      this.getAreasByBranchId({
        loader: loader,
        branchId: branchId,
        limit: limit,
        page: page
      });
    },
    async duplicateAreaService(areaId) {
      let { value } = await Swal.fire({
        title: "Duplicate Coverage Areas!",
        text: "Are you sure you want to duplicate this Coverage Area?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.$router.push({
          path: `/coverage-areas/new`,
          query: { duplicateArea: areaId }
        });
      }
    },
    ...mapActions(["getAreasByBranchId", "getLimit"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setBranchesSearchCriteria"
    ])
  },
  computed: {
    areas: function() {
      if (this.responseAreaByBranch.docs) {
        return this.responseAreaByBranch.docs;
      } else {
        return [];
      }
    },
    ...mapGetters([
      "responseAreaByBranch",
      "sesion",
      "sigout",
      "paginationLimit"
    ])
  },
  filters: {},
  beforeRouteLeave(to, from, next) {
    localHelper.isInAreasModule(
      to.meta.modules,
      this.setBranchesSearchCriteria,
      "destinations"
    );
    next();
  }
};
</script>
